import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { getAfcRiskCount } from "../../common/endpoints";
const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchAfcRiskCount = createApi(
  getAfcRiskCount,
  "GET"
);

const afcRiskCountSlice = createSlice({
  name: "getAfcRiskCount",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAfcRiskCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAfcRiskCount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAfcRiskCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default afcRiskCountSlice.reducer;